import {get} from './axios';
import {ResBanner} from '../../../types/banner';

const baseUrl = '/api/banner';

export const getBanner = async (): Promise<ResBanner> => {
  const res = await get(`${baseUrl}`);
  return res.data as ResBanner
};
